import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as Layers from '@bubble-ui/particle-layers';
export var getDefaultStyleSheet = _ref => {
  var {
    checkbox,
    disabled,
    description,
    designContext,
    detail,
    detailStatus,
    leftIcon,
    logo,
    link,
    logoProps,
    onToggle,
    radio,
    rightIcon,
    rightText,
    isRightTextEllipsis
  } = _ref;
  var logoSize = logoProps !== null && logoProps !== void 0 && logoProps.small ? 30 : logoProps !== null && logoProps !== void 0 && logoProps.medium ? 40 : 50;
  var textPaddingLeft = logo ? logoSize + 15 : leftIcon ? 35 : 0;
  var textPaddingRight = onToggle ? 60 : Boolean(checkbox) || Boolean(radio) ? 35 : 20;
  var descriptionPaddingRight = Boolean(detail) || Boolean(link) ? 0 : textPaddingRight;
  return {
    inputStyle: {
      height: '100%',
      opacity: 0,
      position: 'absolute',
      width: '100%',
      top: -4,
      left: 0,
      zIndex: disabled ? -1 : 1,
      cursor: disabled ? 'auto' : 'pointer',
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    touchableStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      outline: 'none'
    },
    containerStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      cursor: disabled || onToggle ? 'auto' : 'pointer',
      position: 'relative',
      // Android fix
      // https://github.com/facebook/react-native/issues/6802
      marginLeft: -20,
      paddingLeft: 20,
      paddingRight: 20,
      marginRight: -20,
      minHeight: logo ? 70 : 60,
      paddingTop: logo ? 20 : 15,
      paddingBottom: logo ? 20 : 15
    },
    textStyle: _objectSpread({
      flexShrink: 1,
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: textPaddingLeft,
      paddingRight: textPaddingRight,
      zIndex: Layers.FOCUS
    }, rightText == null && !detail && !link ? {
      width: '100%'
    } : {}),
    descriptionStyle: _objectSpread({
      flexGrow: 1,
      flexDirection: 'row',
      paddingLeft: textPaddingLeft,
      paddingRight: descriptionPaddingRight,
      zIndex: Layers.FOCUS,
      width: '100%'
    }, checkbox || radio ? {
      marginTop: 5
    } : {}),
    rightTextWrapperStyle: _objectSpread(_objectSpread({
      flexDirection: 'row',
      flexShrink: isRightTextEllipsis ? 1 : 0,
      paddingRight: detail || link || !rightIcon ? 0 : 20
    }, isRightTextEllipsis ? {
      maxWidth: '50%'
    } : {}), Boolean(logo) && Boolean(description) ? {
      marginTop: -5,
      marginBottom: -5
    } : Boolean(logo) && !description ? {
      marginTop: 5,
      marginBottom: 5
    } : {}),
    rightTextStyle: _objectSpread(_objectSpread({
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 3,
      paddingTop: 2,
      color: designContext.get(detail ? detailStatus === 'success' ? 'colors/text/success' : 'colors/text/default' : 'colors/text/accent', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }, designContext.get('text-style/text/paragraphs/body/medium').styles()), {}, {
      lineHeight: 25,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word'
    }),
    textWrapperStyle: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      flexGrow: 1,
      overflow: 'hidden',
      width: '100%'
    },
    outerTextWrapperStyle: _objectSpread({
      flexDirection: 'column',
      flexGrow: 1,
      alignItems: 'center'
    }, logo ? {
      marginTop: -5,
      marginBottom: -5
    } : checkbox || radio ? {
      marginTop: 5,
      marginBottom: 5
    } : {}),
    leftIconStyle: {
      position: 'absolute',
      top: 20,
      left: 20
    },
    logoStyle: {
      position: 'absolute',
      top: (70 - logoSize) / 2,
      left: 20
    },
    avatarStyle: {
      position: 'absolute',
      top: 10
    },
    rightIconStyle: {
      position: 'absolute',
      right: 20,
      top: logo ? 25 : 20 // (minHeight - 20) / 2
    },

    checkboxStyle: {
      position: 'absolute',
      right: 20,
      top: logo ? 21 : 16
    },
    radioStyle: {
      position: 'absolute',
      right: 20,
      top: logo ? 25 : 20
    },
    toggleStyle: {
      position: 'absolute',
      right: 15,
      top: 17
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map